import { render, staticRenderFns } from "./BindwidthRecord.vue?vue&type=template&id=4635b94c&scoped=true&"
import script from "./BindwidthRecord.vue?vue&type=script&lang=js&"
export * from "./BindwidthRecord.vue?vue&type=script&lang=js&"
import style0 from "./BindwidthRecord.vue?vue&type=style&index=0&id=4635b94c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4635b94c",
  null
  
)

export default component.exports